import FirmaPagarePanel from '@/components/settings/firma-pagare/FirmaPagarePanel';

export default function FirmaPagarePage() {
  return <FirmaPagarePanel />;
}
